// Odmítnutí souhlasu z URL (?cg_consent=reject) — typicky WebView v mobilní
// aplikaci, která za uživatele „odklikne" banner. Záměrně jen směr ODMÍTNOUT:
// souhlas musí být aktivní projev vůle uživatele (GDPR), odkaz s parametrem
// by mohl rozeslat kdokoli.
import type { CategoryDef, ConsentState } from './types';

export const URL_CONSENT_PARAM = 'cg_consent';

/** Přečte z URL požadavek aplikace. Jiná hodnota než `reject` se ignoruje. */
export function readUrlConsent(href: string): 'reject' | null {
  let value: string | null;
  try {
    value = new URL(href).searchParams.get(URL_CONSENT_PARAM);
  } catch {
    return null;
  }
  if (value === null) return null;
  if (value.trim().toLowerCase() === 'reject') return 'reject';
  console.warn(
    `[CookieGobbler] ${URL_CONSENT_PARAM}=${value} se ignoruje — přes URL jde jen odmítnutí (reject).`,
  );
  return null;
}

/** URL bez parametru cg_consent, nebo null, pokud v ní nebyl. */
export function stripUrlConsent(href: string): string | null {
  try {
    const url = new URL(href);
    if (!url.searchParams.has(URL_CONSENT_PARAM)) return null;
    url.searchParams.delete(URL_CONSENT_PARAM);
    return url.toString();
  } catch {
    return null;
  }
}

/** True, pokud jsou všechny nepovinné kategorie odmítnuté. */
export function isAllRejected(state: ConsentState, categories: CategoryDef[]): boolean {
  return categories.every((c) => c.required || !state[c.id]);
}
